import { render, staticRenderFns } from "./deliver_goods_order.vue?vue&type=template&id=3b8cd322&scoped=true"
import script from "./deliver_goods_order.vue?vue&type=script&lang=js"
export * from "./deliver_goods_order.vue?vue&type=script&lang=js"
import style0 from "./deliver_goods_order.vue?vue&type=style&index=0&id=3b8cd322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8cd322",
  null
  
)

export default component.exports